import cx from 'classnames'

import { useT } from '@/utils/language'
import { PlanType } from '@/utils/plan'

import styles from './PlanPriceCard.module.css'

type CustomPlanPriceCardProps = {
  className?: string
  preset: 'subscription' | 'normal'
  hint: string
  value: string
}

function CustomPlanPriceCard(props: CustomPlanPriceCardProps) {
  const T = useT()
  const { className, preset, hint, value } = props
  return (
    <div
      className={cx(styles.container, className, {
        [styles.subscription]: preset === 'subscription',
        [styles.normal]: preset === 'normal',
      })}
    >
      <div className={styles.hint}>{hint}</div>
      <div className={styles.valueContainer}>
        <div className={styles.value}>{value}</div>
        <div className={styles.tax}>{T('withTax')}</div>
      </div>
    </div>
  )
}

type PlanPriceCardProps = {
  type: PlanType
  className?: string
}

function PlanPriceCard(props: PlanPriceCardProps) {
  const { type, className } = props
  const T = useT()

  if (type === PlanType.Subscription) {
    return (
      <CustomPlanPriceCard
        className={className}
        preset="subscription"
        hint={T('subscriptionPlanPriceHint')}
        value={T('subscriptionPlanPriceValue')}
      />
    )
  }

  if (type === PlanType.Normal) {
    return (
      <div className={cx(styles.normalPlanContainer, className)}>
        <div className={styles.priceTable}>
          <div className={styles.priceTableTitle}>
            {T('normalPlanPriceTitle')}
          </div>
          {[
            [T('labelUnder1Hour'), T('priceUnder1Hour')],
            [T('labelUnder3Hours'), T('priceUnder3Hours')],
            [T('labelUnder6Hours'), T('priceUnder6Hours')],
            [T('labelUnder1Day'), T('priceUnder1Day')],
            [T('labelUnder2Days'), T('priceUnder2Days')],
            [T('labelUnder3Days'), T('priceUnder3Days')],
            [T('labelUnder30Days'), T('priceUnder30Days')],
            [T('labelUnder60Days'), T('priceUnder60Days')],
            [T('labelUnder90Days'), T('priceUnder90Days')],
            [T('label90Days'), T('price90Days')],
          ].map(([label, price]) => (
            <div className={styles.priceRow} key={label}>
              <div className={styles.priceCellLeft}>{label}</div>
              <div className={styles.priceCellRight}>
                <span className={styles.priceValue}>{price}</span>
                <span className={styles.priceTax}>{T('withTax')}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    )
  }

  return null
}

export default PlanPriceCard
